<template>
    <div>
        <div class="ui basic segment mb-0">
            <div class="ui message mb-0">
                <div class="header">
                    <a target="_blank" href="https://docs.google.com/spreadsheets/d/1moN1CL1FWx00M_vfXgOwL3TlCwvhJAv1xLM7Dw1_3wU">Descarga aquí</a>
                    el formato de ejemplo para actualizar empresas dragón.
                </div>
                <ul class="list">
                    <li>El archivo debe ser descargado en formato <strong>.tsv</strong> (separado por taulaciones)</li>
                    <li>En el caso de las empresas extranjeras, si la razón social cambia, <strong>se generará un nuevo registro</strong>, en cambio, si solo hay cambios en los demás datos, se actualizará.</li>
                    <li><strong>Aquellas empresas que sean creadas, serán enviadas a autorización.</strong></li>
                </ul>
            </div>

            <div class="ui form mt-15" v-show="importData.length === 0 && !processed">
                <div class="fields">
                    <div class="five wide required field" :class="{'error': !file }">
                        <label>Archivo de dragones a actualizar:</label>
                        <input
                            type="file"
                            name="file"
                            id="file"
                            ref="file"
                            accept=".tsv"
                            @change="handleFileUpload()"
                        />
                    </div>
                    <div class="five wide field">
                        <!-- :disabled="!file" -->
                        <sui-button primary content="Importar" icon="upload" style="margin-top: 25px" @click="submitFile"/>
                    </div>
                </div>
            </div>
        </div>

        <sui-segment clearing class="white-segment">
            <sui-button floated="right" negative @click="cancelImport" v-if="dataToImport.length > 0 && !processed">
              Cancelar
            </sui-button>
            <sui-button floated="right" secondary @click="confirmImport" v-if="dataToImport.length > 0 && !processed">
              Confirmar importación
            </sui-button>
            <sui-button floated="right" color="blue" @click="cancelImport" v-if="processed">
              Volver a cargar
            </sui-button>
        </sui-segment>

        <sui-table size="small" striped>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell :width="1">RFC</sui-table-header-cell>
                    <sui-table-header-cell :width="3">RAZÓN SOCIAL</sui-table-header-cell>
                    <sui-table-header-cell :width="2">CONCEPTO SCIAN</sui-table-header-cell>
                    <sui-table-header-cell :width="2">PAIS</sui-table-header-cell>
                    <sui-table-header-cell :width="2">DIRECCIÓN</sui-table-header-cell>
                    <sui-table-header-cell :width="2">CIUDAD</sui-table-header-cell>
                    <sui-table-header-cell :width="1">CÓDIGO POSTAL</sui-table-header-cell>
                    <sui-table-header-cell :width="1">EMAIL</sui-table-header-cell>
                    <sui-table-header-cell :width="1">TELÉFONO</sui-table-header-cell>
                    <sui-table-header-cell :width="1">ACCIÓN</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-for="(row, index) in dataToImport" :key="index">
                    <sui-table-cell>{{ row.rfc }}</sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.razonSocial !== row.nuevaRazonSocial">
                            <span class="old-info"> {{ row.razonSocial }}</span><br>
                            <span class="updated-info">{{ row.nuevaRazonSocial }}</span>
                        </div>
                        <span v-else> {{ row.razonSocial }}</span>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.scianConcept !== row.scianConceptOriginal">
                            <span class="old-info" v-if="row.scianConceptOriginal"> {{ row.scianConceptOriginal }}<br></span>
                            <span class="updated-info">{{ row.scianConcept }}</span>
                            <span class="updated-info" v-if="row.scianConceptName"><br>{{ row.scianConceptName || ''}}</span>
                        </div>
                        <div v-else>
                            {{ row.scianConcept }}
                            <span v-if="row.scianConceptName"><br>{{ row.scianConceptName || ''}}</span>
                        </div>
                        <div v-if="row.scianConceptErrors" class="errors">
                            {{row.scianConceptErrors}}
                        </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.pais !== row.paisOriginal">
                                <span class="old-info" v-if="row.paisOriginal"> {{ row.paisOriginal }}<br></span>
                                <span class="updated-info">{{ row.pais }}</span>
                                <span class="updated-info" v-if="row.paisName"><br>{{ row.paisName || ''}}</span>
                            </div>
                            <div v-else>
                                {{ row.pais }}
                                <span v-if="row.paisName"><br>{{ row.paisName || ''}}</span>
                            </div>
                            <div v-if="row.paisErrors" class="errors">
                                {{row.paisErrors}}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.direccion !== row.direccionOriginal">
                                <span class="old-info" v-if="row.direccionOriginal"> {{ row.direccionOriginal }}<br></span>
                                <span class="updated-info">{{ row.direccion }}</span>
                            </div>
                            <div v-else>
                                {{ row.direccion }}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.ciudad !== row.ciudadOriginal">
                                <span class="old-info" v-if="row.ciudadOriginal"> {{ row.ciudadOriginal }}<br></span>
                                <span class="updated-info">{{ row.ciudad }}</span>
                            </div>
                            <div v-else>
                                {{ row.ciudad }}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.codigoPostal !== row.codigoPostalOriginal">
                                <span class="old-info" v-if="row.codigoPostalOriginal"> {{ row.codigoPostalOriginal }}<br></span>
                                <span class="updated-info">{{ row.codigoPostal }}</span>
                            </div>
                            <div v-else>
                                {{ row.codigoPostal }}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.email !== row.emailOriginal">
                                <span class="old-info" v-if="row.emailOriginal"> {{ row.emailOriginal }}<br></span>
                                <span class="updated-info">{{ row.email }}</span>
                            </div>
                            <div v-else>
                                {{ row.email }}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div v-if="row.actualizar && row.telefono !== row.telefonoOriginal">
                                <span class="old-info" v-if="row.telefonoOriginal"> {{ row.telefonoOriginal }}<br></span>
                                <span class="updated-info">{{ row.telefono }}</span>
                            </div>
                            <div v-else>
                                {{ row.telefono }}
                            </div>
                    </sui-table-cell>
                    <sui-table-cell>
                        <div class="ui tiny horizontal label"
                            :class="{
                                'blue': row.status === 'ACTUALIZAR',
                                'red': row.status === 'IGNORADA',
                                'green': row.status === 'NUEVO'
                            }">
                            {{row.status}}
                        </div>
                    </sui-table-cell>
                </sui-table-row>
                <sui-table-row v-for="(row, index) in processedData" :key="index">
                    <sui-table-cell> {{ row.rfc }} </sui-table-cell>
                    <sui-table-cell> {{ row.razonSocial }} </sui-table-cell>
                    <sui-table-cell> {{ row.scianConcept }} {{ row.scianConceptName }} </sui-table-cell>
                    <sui-table-cell> {{ row.pais }} {{ row.paisName }} </sui-table-cell>
                    <sui-table-cell> {{ row.direccion }} </sui-table-cell>
                    <sui-table-cell> {{ row.ciudad }} </sui-table-cell>
                    <sui-table-cell> {{ row.codigoPostal }} </sui-table-cell>
                    <sui-table-cell> {{ row.email }} </sui-table-cell>
                    <sui-table-cell> {{ row.telefono }} </sui-table-cell>
                    <sui-table-cell>
                        <i class="icon"
                            :class="{
                                'check circle green': row.created || row.updated,
                                'ban': row.unchanged,
                                'times cicle red': row.skipped }"></i>
                        <span v-if="row.created">Creada</span>
                        <span v-if="row.updated">Actualizada</span>
                        <span v-if="row.unchanged">Sin cambios</span>
                        <span v-if="row.skipped">Con Error</span>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
        </sui-table>
    </div>
</template>

<script>
import FactoringCompanyService from '@/services/FactoringCompanyService'
import Utils from '@/common/Utils.js'

export default {
    name: 'CompaniesMassiveUpdate',

    data () {
        return {
            baseUrl: process.env.VUE_APP_BASEPATH || '/',
            file: '',
            fileName: '',
            processed: false,
            importData: [],
            processedData: [],
            loader: undefined
        }
    },

    mounted () {
        if (!Utils.userHasPerm('can_massive_update_dragons')) {
            this.$swal({
                title: 'No tienes permiso para realizar la acción',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Volver al listado',
                confirmButtonColor: '#2BBA45',
                showCloseButton: false
            }).then(async (result) => {
                let routeData = this.$router.resolve({ name: 'home' })
                window.open(routeData.href, '_self')
            })
        }
    },

    methods: {

        async handleFileUpload () {
            let error = false
            let extension = this.$refs.file.files[0].name.split('.').pop()

            if (!extension) {
                error = true
            } else {
                if (extension !== 'tsv') error = true
            }

            if (error) {
                return this.$swal({
                    icon: 'error',
                    title: 'Archivo inválido',
                    html: 'Solo es posible procesar archivos separados por tabulaciones (extensión .tsv)',
                    showCancelButton: false,
                    showConfirmButton: true,
                    showCloseButton: false,
                    confirmButtonColor: '#2BBA45'
                })
            }
            if (this.$refs.file.files) {
                this.file = this.$refs.file.files[0]
                this.fileName = this.file.name
            }
        },

        async submitFile () {
            if (!this.file) {
                return this.$swal({
                    icon: 'error',
                    title: 'Error',
                    html: 'Selecciona el archivo con la información a actualizar',
                    showCancelButton: false,
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonColor: '#2BBA45'
                })
            }

            this.loader = this.$loading.show()
            try {
                let { fileName } = await FactoringCompanyService.uploadFile(this.file)
                this.fileName = fileName
                await this.getDataFromFile()
                this.loader.hide()
            } catch (error) {
                console.error(error.data)
                this.loader.hide()
                let msg = error.data && error.data.message ? error.data.message : 'Contacta al administrador'
                return this.$swal({
                    icon: 'error',
                    title: 'Error al procesar archivo',
                    html: msg,
                    showCancelButton: false,
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonColor: '#2BBA45'
                })
            }
        },

        async getDataFromFile () {
            try {
                let { data } = await FactoringCompanyService.getDataFromFile({ fileName: this.fileName })
                this.importData = data
            } catch (error) {
                this.loader.hide()
                return this.$swal({
                    icon: 'error',
                    title: 'Error al procesar archivo',
                    html: error && error.data.message ? error.data.message : 'Contacta al administrador',
                    showCancelButton: false,
                    showConfirmButton: true,
                    showCloseButton: false,
                    confirmButtonColor: '#2BBA45'
                })
            }
        },

        cancelImport () {
            this.fileName = ''
            this.file = ''
            this.importData = []
            this.$refs.file.value = null
            this.processed = false
            this.processedData = []
        },

        confirmImport () {
            if (this.dataToImport) {
                this.$swal({
                    title: '¿Estas seguro?',
                    html: 'Una vez realizada la acción, no se puede revertir',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, importar',
                    cancelButtonText: 'No, cancelar'
                }).then(async result => {
                    this.processed = true
                    if (result.value) {
                        this.loader = this.$loading.show()
                        let response = await FactoringCompanyService.importDataFromFile({ fileName: this.fileName })
                        let created = response.data.created || []
                        let updated = response.data.updated || []
                        let unchanged = response.data.unchanged || []
                        let skipped = response.data.skipped || []
                        this.importData = []
                        this.processedData = updated.concat(created, skipped, unchanged)

                        if (response.status === 'success') {
                            this.loader.hide()
                            this.$swal({
                                title: 'Proceso finalizado',
                                html: 'Los datos han sido actualizados correctamente. <br> Recuerda que las dragones nuevas fueron enviadas para su autorización.',
                                icon: 'success',
                                showCancelButton: false,
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Ok'
                            })
                        } else {
                            this.loader.hide()
                            this.$swal({
                                title: 'Error',
                                html: 'Error al procesar el archivo, contacta al administrador',
                                icon: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Ok'
                            })
                        }
                    } else {
                        this.cancelImport()
                    }
                })
            } else {
                return this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: 'No hay registros para importar'
                })
            }
        }
    },

    computed: {
        dataIgnored () {
            let companies = this.importData.filter(item => item.status === 'IGNORADA')
            return companies
        },

        dataToUpdate () {
            let companies = this.importData.filter(item => item.status === 'ACTUALIZAR')
            return companies
        },

        dataNew () {
            let companies = this.importData.filter(item => item.status === 'NUEVO')
            return companies
        },

        dataWithoutChanges () {
            let companies = this.importData.filter(item => item.status === 'SIN CAMBIOS')
            return companies
        },

        dataToImport () {
            return this.dataToUpdate.concat(this.dataNew, this.dataIgnored, this.dataWithoutChanges)
        }
    }
}
</script>

<style scoped>
    .mb-0 { margin-bottom: 0px !important; }
    .mt-15 { margin-top: 15px !important; }
    .mb-15 { margin-bottom: 15px !important; }
    .old-info { text-decoration: line-through !important;}
    .updated-info { font-weight: bold !important;}
    .white-segment {
        border: 0px!important;
        box-shadow: 0 0 white !important;
        margin-top: 0px;
        margin-bottom: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .errors {
        color: red!important;
        font-weight: bold !important;
    }
    .ui.small.table {
        font-size: 0.8em !important;
    }
</style>
